<template>
  <div>
    <basic-container>
      <div>
        <el-form
          ref="form"
          :model="projectWarrantyForm"
        >
          <el-form-item
            label="工程项目名称"
            label-width="100px"
          >
            <div style="display: flex;width:300px;">
              <el-select
                v-model="projectWarrantyForm.projectItem"
                placeholder="请选择工程项目名称"
                width="200"
                @change="chooseProjectItem"
                disabled
                value-key="id"
              >
                <el-option
                  v-for="item in projectItems"
                  :key="item.id"
                  :label="item.name"
                  :value='item'
                ></el-option>
              </el-select>
            </div>
          </el-form-item>
          <el-form-item
            label="关联服务商"
            label-width="100px"
          >
            <div style="display: flex;width:300px;">
              <el-select
                v-model="agentId"
                placeholder="请选择关联服务商"
                width="200"
                disabled
              >
                <el-option
                  v-for="item in agentIds"
                  :key="item.id"
                  :label="item.company"
                  :value='item.id'
                ></el-option>
              </el-select>
            </div>
          </el-form-item>
          <el-form-item label='工程质保配置'>
            <div
              v-for="(item,index) in tableData1"
              :key="index"
            >
              <el-table
                :data="item"
                :span-method="objectSpanMethod"
                border
                style="width: 100%; margin-top: 20px"
              >
                <el-table-column
                  prop="yyqd"
                  label="预约渠道"
                  min-width="120"
                >
                  <template slot-scope="scope">
                    <el-select
                      v-model="scope.row.clientType"
                      placeholder="请选择预约渠道"
                      disabled
                      width="300"
                    >
                      <el-option
                        v-for="item in clientTypes"
                        :key="item.value"
                        :label="item.label"
                        :value='item.value'
                      ></el-option>
                    </el-select>
                  </template>
                </el-table-column>
                <el-table-column
                  prop="area"
                  min-width="250"
                  label="服务区域"
                >
                  <template slot-scope="scope">
                    <div>
                      <el-input
                        v-model='scope.row.area'
                        disabled
                      >
                      </el-input>
                    </div>
                  </template>
                </el-table-column>
                <el-table-column
                  prop="projectList"
                  align="center"
                  label="字段名称"
                  min-width="900"
                >
                  <template slot-scope="scope">
                    <div
                      v-for="(i,idx) in tableData1[index]"
                      v-bind:key='idx'
                    >
                      <el-table
                        :data="tableData1[index][idx].projectGuaranteeList"
                        :span-method="inSpanMethod"
                        border
                        style="width: 100%; margin-top: 20px"
                      >
                        <el-table-column
                          prop="name"
                          label="工程阶段名称"
                          width="120"
                        >
                          <template slot-scope="scope">
                            {{scope.row.name}}
                          </template>
                        </el-table-column>
                        <el-table-column
                          prop="type"
                          label="质保时间类型"
                          min-width="100"
                        >
                          <template slot-scope="scope">
                            <el-select
                              v-model="scope.row.type"
                              placeholder="请选择质保时间类型"
                              width="300"
                            >
                              <el-option
                                v-for="item in types"
                                :key="item.value"
                                :label="item.label"
                                :value='item.value'
                              ></el-option>
                            </el-select>
                          </template>
                        </el-table-column>
                        <el-table-column
                          prop="time"
                          label="质保时间"
                          min-width="100"
                        >
                          <template slot-scope="scope">
                            <el-input v-model="scope.row.time"></el-input>
                          </template>
                        </el-table-column>
                        <el-table-column
                          prop="fileList"
                          label="电子质保卡"
                          min-width="100"
                        >
                          <template slot-scope="scope">
                            <el-upload
                              class="upload-demo"
                              action="#"
                              accept=".jpg, .jpeg,.png"
                              :on-remove="handleRemove"
                              ref="upload"
                              list-type="picture"
                              :multiple="true"
                              :http-request="fnUploadDescribeImgs"
                              :limit="1"
                              :on-exceed="handleExceed"
                              :file-list="scope.row.fileList"
                            >
                              <el-button
                                size="small"
                                type="primary"
                                @click="isIndex(index,scope.$index)"
                              >点击上传</el-button>
                              <div
                                slot="tip"
                                class="el-upload__tip"
                              >只能上传jpg/png文件，且不超过500kb</div>
                            </el-upload>
                          </template>
                        </el-table-column>
                      </el-table>
                    </div>
                  </template>
                </el-table-column>
              </el-table>
            </div>
          </el-form-item>
        </el-form>
      </div>
      <div style='width:100%;display:flex;flex-flow:row nowrap;justify-content: center;margin-top:20px'>
        <el-button
          type="primary"
          size="small"
          @click="submit"
        >确定修改</el-button>
      </div>
    </basic-container>
  </div>
</template>

<script>
import { DIC } from "@/const/dic";
import { resolveUrlPath, setUrlPath } from "@/util/util";
import {
  findAllSuperiorDepartment,
  findEngineeringDynamicId,
  findEngineeringProjectAll,
  findEngineeringGuaranteeDetail,
  editEngineeringGuarantee
} from "@/api/work/projectWarranty";
import { getAliyunPublicToken } from "@/api/oss/aliyun";
import oss from "ali-oss";
import md5 from "js-md5";

export default {
  data() {
    return {
      projectItems: [],
      categoryTypes: DIC.SERVICEITEM_YYTYPE,
      isPas: false,
      types: DIC.SERVICE_WARRANTY_DATE_TYPE,
      inputTypes: [],
      dataSources: [],
      currIndex: {},
      fileList: [],
      agentIds: [],
      agentId: {},
      clientTypes: DIC.SERVICEITEM_TYPE,
      superiorIds: [],
      areas: [],
      citys: [],
      provinces: [],
      projectWarrantyForm: {},
      tableData1: []
    };
  },
  created() {
    this.projectWarrantyForm.projectItem = {
      id: this.$router.currentRoute.query.id
    };
    findEngineeringGuaranteeDetail(this.$router.currentRoute.query.id).then(
      res => {
        let data = JSON.parse(res.data);
        console.log(data);
        this.agentId = data.agentId;
        let list = [];
        let obj = {};
        for (let i = 0; i < data.guaranteeChannels.length; i++) {
          list[i] = [];
          let dtobj = {};
          console.log(data.guaranteeChannels[i].projectGuaranteeList);
          for (let j of data.guaranteeChannels[i].projectGuaranteeList) {
            if (j.image) {
              j.fileList = [
                {
                  name: j.name,
                  url: j.image
                }
              ];
              this.fileList.push({ name: j.name, url: j.image });
            }
          }
          dtobj.clientType = data.guaranteeChannels[i].clientType;
          dtobj.id = data.guaranteeChannels[i].id;
          dtobj.projectGuaranteeList =
            data.guaranteeChannels[i].projectGuaranteeList;
          dtobj.area =
            (data.guaranteeChannels[i].provinceName == null
              ? ""
              : data.guaranteeChannels[i].provinceName) +
            (data.guaranteeChannels[i].cityName == null
              ? ""
              : data.guaranteeChannels[i].cityName) +
            (data.guaranteeChannels[i].areaName == null
              ? ""
              : data.guaranteeChannels[i].areaName);

          list[i].push(dtobj);
          obj[i] = list[i];
        }
        this.tableData1 = obj;
      }
    );
    findEngineeringProjectAll().then(res => {
      console.log(res);
      let data = JSON.parse(res.data);
      this.projectItems = data;
    });
    findAllSuperiorDepartment().then(res => {
      let data = JSON.parse(res.data);
      console.log(data);

      this.agentIds = data;
      this.agentIds.push({ company: "社区", id: "0" });
    });
  },
  methods: {
    isIndex(index, idx) {
      console.log(index, idx);
      this.currIndex.index = index;
      this.currIndex.idx = idx;
    },
    handleRemove(file, fileList) {
      console.log(this);
      console.log(file, fileList);
      this.fileList = [];
    },
    handlePreview(file) {
      console.log(file);
    },
    handleExceed(files, fileList) {
      this.$message.warning(
        `当前限制选择 1 个文件，本次选择了 ${
          files.length
        } 个文件，共选择了 ${files.length + fileList.length} 个文件`
      );
    },

    chooseProjectItem(e) {
      console.log(e);
    },
    selectCategory(e) {
      console.log(e);
      if (e.channel == null) {
        this.$message({
          showClose: true,
          message: e,
          type: "error"
        });
        return;
      }
      let list = e.channel.split(",");
      let obj = {};
      for (let i in list) {
        console.log(e.configs[i]);
        let dtobj = {};
        dtobj.clientType = e.configs[i].clientType;
        dtobj.agentId = e.configs[i].agentId;
        dtobj.configId = e.configs[i].id;

        dtobj.area =
          (e.configs[i].provinceName == null ? "" : e.configs[i].provinceName) +
          (e.configs[i].cityName == null ? "" : e.configs[i].cityName) +
          (e.configs[i].areaName == null ? "" : e.configs[i].areaName);
        list[i] = [];
        list[i].push(dtobj);
        obj[i] = list[i];
      }
      console.log(list);
      console.log(obj);
      this.tableData1 = obj;
    },
    submit() {
      let item = {
        close: true,
        label: "编辑工程质保",
        value: "/work/projectWarranty/edit"
      };
      console.log(this.tableData1);
      if (this.fileList.length == 0) {
        this.$message({
          showClose: true,
          message: "请上传质保图片",
          type: "error"
        });
        return;
      }
      let guaranteeChannels = [];
      let obj = {};
      obj.id = this.projectWarrantyForm.projectItem.id;
      for (let item in this.tableData1) {
        console.log(this.tableData1[item][0]);
        guaranteeChannels.push(this.tableData1[item][0]);
        let dtobj = {};
        // dtobj.id = list.push(this.tableData1[item][0]);
        console.log(dtobj);
      }
      obj.guaranteeChannels = guaranteeChannels;
      console.log(obj);
      let params = obj;
      editEngineeringGuarantee(params).then(res => {
        console.log(res);
        if (res.code == "200") {
          this.$message({
            showClose: true,
            message: "编辑成功",
            type: "success"
          });
          if (!this.isPas) {
            this.$store.commit("DEL_TAG", item);
            let obj = {
              value: "/work/projectWarranty",
              label: "工程抽成管理"
            };
            this.$router.push({
              path: resolveUrlPath(obj.value, obj.label),
              query: obj.query
            });
            this.isPas = true;
          }
        } else {
          if (!this.isPas) {
            this.$message({
              showClose: true,
              message: res.message,
              type: "error"
            });
            this.isPas = true;
            setTimeout(() => {
              this.isPas = false;
            }, 1000);
          }
        }
      });
    },
    handleSteppingDelete(index, row) {
      console.log(index, row);
      // this.tableData.splice(index, 1);
      console.log(this.tableData1[row].length);
      if (this.tableData1[row].length == 1) {
        this.$message({
          showClose: true,
          message: "动态表单不能为空",
          type: "error"
        });
      } else {
        this.tableData1[row].splice(index, 1);
      }
    },
    handle1SteppingDelete(index, row) {
      //   this.propertiesList.splice(index, 1);
      var isFst;
      if (row.id != "undefined" && row.id != null) {
        isFst = row.id;
      } else {
        isFst = row;
      }
      console.log(this.tableDate, row);
      if (isFst == "设备调试") {
        this.list1["sed"].splice(index, 1);
      } else {
        this.list1["fst"].splice(index, 1);
      }
    },
    handleAddRows(index, row) {
      console.log(this.tableData1[row][0]);
      console.log(index, row);
      let list = {
        targetType: "CONFIG"
      };
      // list.push(this.tableData1[row][0]);
      this.tableData1[row].push(list);
    },
    objectSpanMethod({ row, column, rowIndex, columnIndex }) {
      if (columnIndex === 0) {
        if (rowIndex % 100 === 0) {
          return {
            rowspan: 100,
            colspan: 1
          };
        } else {
          return {
            rowspan: 0,
            colspan: 0
          };
        }
      }
      if (columnIndex === 1) {
        if (rowIndex % 100 === 0) {
          return {
            rowspan: 100,
            colspan: 1
          };
        } else {
          return {
            rowspan: 0,
            colspan: 0
          };
        }
      }
      if (columnIndex === 2) {
        if (rowIndex % 100 === 0) {
          return {
            rowspan: 100,
            colspan: 1
          };
        } else {
          return {
            rowspan: 0,
            colspan: 0
          };
        }
      }
      if (columnIndex === 11) {
        if (rowIndex % 100 === 0) {
          return {
            rowspan: 100,
            colspan: 1
          };
        } else {
          return {
            rowspan: 0,
            colspan: 0
          };
        }
      }
    },
    inSpanMethod({ row, column, rowIndex, columnIndex }) {},
    async fnUploadDescribeImgs(option) {
      this.tableLoading = true;
      console.log(option);
      var obj = {};
      obj.name = option.file.name;
      getAliyunPublicToken().then(res => {
        let data = JSON.parse(res.data);
        let client = new oss({
          region: data.point,
          endPoint: data.point,
          accessKeyId: data.accessKeyId,
          accessKeySecret: data.accessKeySecret,
          Expiration: data.expiration,
          bucket: data.bucketName,
          stsToken: data.securityToken
        });
        const storeAs = md5(option.file.name) + new Date().getTime();
        client
          .multipartUpload(storeAs, option.file, {})
          .then(results => {
            console.log(results);
            let res = results.res.requestUrls;
            let files = new Array();
            for (let url in res) {
              let file = new Object();
              file.label = storeAs;
              file.value = url;
              files.push(file);
            }
            // this.fileList = files;
            let array = results.res.requestUrls[0].split("?");
            obj.url = array[0];

            //上传多张图片
            // if (this.tableData1[this.currIndex][0].image == undefined) {
            //   this.tableData1[this.currIndex][0].image = array[0];
            // } else {
            //   let aa = "";
            //   this.tableData1[this.currIndex][0].image = aa.concat(
            //     this.tableData1[this.currIndex][0].image,
            //     ",",
            //     array[0]
            //   );
            //   console.log(this.tableData1[this.currIndex][0].image);
            // }
            // 上传单张图片
            console.log(this.currIndex);
            this.tableData1[this.currIndex.index][0].projectGuaranteeList[
              this.currIndex.idx
            ].image = array[0];
            // this.fileList.push(obj);
            this.describeImgs.push(array[0]);
            this.tableLoading = false;
          })
          .catch(err => {});
      });
    }
  }
};
</script>

<style>
</style>